module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-time-usage"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Medarbejdere\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectCustomer
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'hoursWithCustomers') ? _c('div', [_vm._v("\n                                " + _vm._s(props.row.hoursWithCustomers) + " %\n                            ")]) : (props.column.field == 'sicknessPercent') ? _c('div', [_vm._v("\n                                " + _vm._s(props.row.sicknessPercent) + " %\n                            ")]) : _vm._e()]
      }
    }], null, false, 6116341)
  }) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [(_vm.selectedRow && !_vm.loading) ? _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeUsage.singleEmployee"
    }
  }), _vm._v("\n                    " + _vm._s(_vm.selectedRow.name) + "\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedRow.hours_division.series[0] > 0 && _vm.selectedRow !== null) ? _c('pie', {
    attrs: {
      "headline": 'Hvad bruger ' + _vm.selectedRow.name.split(' ')[0] + ' tiden på?',
      "series": _vm.selectedRow.hours_division.series,
      "labels": _vm.selectedRow.hours_division.labels,
      "division": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedRow.hours_division.series[0] === 0) ? _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Hvad bruger " + _vm._s(_vm.selectedRow.name.split(' ')[0]) + " tiden på?\n                                ")]), _vm._v(" "), _vm._m(0)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedRow.hours_with_customers.labels.length > 0 && _vm.selectedRow !== null) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af tid hos kunderne",
      "series": _vm.selectedRow.hours_with_customers.series,
      "labels": _vm.selectedRow.hours_with_customers.labels,
      "division": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedRow.hours_with_customers.labels.length === 0) ? _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Fordeling af tid hos kunderne\n                                ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedRow.hours_without_customers.labels.length > 0) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af anden tid",
      "series": _vm.selectedRow.hours_without_customers.series,
      "labels": _vm.selectedRow.hours_without_customers.labels,
      "division": false
    }
  }) : _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Fordeling af anden tid\n                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Ingen anden tid registreret\n                                ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedRow.hours_excluded && _vm.selectedRow.hours_excluded.labels.length > 0) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af fravær",
      "series": _vm.selectedRow.hours_excluded.series,
      "labels": _vm.selectedRow.hours_excluded.labels,
      "division": false
    }
  }) : _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Fordeling af fravær\n                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Intet fravær registreret\n                                ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('strong', [_vm._v("Tid brugt hos kunderne")]), _vm._v(" er beregnet ud af medarbejderens reelle tid til rådighed: den teoretiske arbejdstid (arbejdsdage × timer/uge) fratrukket fraværstimer. "), _c('strong', [_vm._v("Fravær")]), _vm._v(" er de tidsregistreringstyper, der er sat til \"Skjult\" under "), _c('router-link', {
    attrs: {
      "to": "/indstillinger"
    }
  }, [_vm._v("Indstillinger → Tidsregistreringstyper")]), _vm._v(" — de fratrækkes tid til rådighed og tæller derfor ikke med i kundetidsprocenten.\n                    ")], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("selectedRow")]), _c('br'), _vm._v("\n                        labels: " + _vm._s(_vm.selectedRow.hours_without_customers.labels)), _c('br'), _vm._v("\n                        series: " + _vm._s(_vm.selectedRow.hours_without_customers.series) + "\n                        "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Allan Jensen")]), _c('br'), _vm._v("\n                        labels: " + _vm._s(_vm.rows[1].hours_without_customers.labels)), _c('br'), _vm._v("\n                        series: " + _vm._s(_vm.rows[1].hours_without_customers.series) + "\n                    ")])])]) : _c('div', [_vm._v("\n                Vælg en svend for at se fordelingen af hans registrerede timer\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Ingen tid hos kunderne\n                                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Ingen tid hos kunderne\n                                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2815c14f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/learning/components/employeeTimeUsage.vue
// module id = 829
// module chunks = 0